import { InjectionToken } from '@angular/core';
import { BookingFilterConfig } from '../interface/booking-filter-config';

export const BOOKING_FILTER_CONFIG = new InjectionToken<BookingFilterConfig>('BookingFilterConfig');
